import { InboxMessage } from '@src/main/modules/messages/domain/message/inbox/inbox-message.interface';
import { createInboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/InboxMessageHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useMemo } from 'react';

export const useFindInboxMessageById = (
  id: string,
  options?: Omit<UseQueryOptions<InboxMessage>, 'queryKey' | 'queryFn'>,
) => {
  const { user } = useAuth();

  const tokenProvider = useMemo(
    () => ({
      getToken: async () => user?.token ?? '',
    }),
    [user?.token],
  );

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createInboxMessageHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useQuery<InboxMessage>({
    queryKey: ['inboxMessages', id],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await repository.findById(id);
    },
    enabled: !!repository && !!id,
    staleTime: 1000 * 60,
    ...options,
  });
};
